module.exports = __webpack_public_path__ + "img/1557614109687619585.4f559286.png";